import NameTranslationParamMapper from "../../core/service/translations/NameTanslationParamMapper";
import { parseBooleanValue } from "../../util";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";

const OrganisationIndexGroupParamMapper = (item: IOrganisationIndexGroup) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    harmonized: parseBooleanValue(item.harmonized),
    nameTranslations: item.nameTranslations?.map((item) =>
      NameTranslationParamMapper(item)
    )
  };
};

export default OrganisationIndexGroupParamMapper;
